import { Link, useParams } from "react-router-dom";

import { ArrowLeft, Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { CenterInfraDetail } from "@/features/servers/components/CenterInfraDetail";
import { usePermissions } from "@/features/rbac/hooks/usePermissions";
import { useUser } from "@/features/users/hooks/useUsers";

/**
 * Vista de edición de infraestructura.
 */
export default function ServerEditPage() {
  const { institutionUid } = useParams<{ institutionUid: string }>();
  const { data: user, isLoading, error } = useUser(institutionUid ?? "");
  const { can } = usePermissions();
  const canManageCatalog = can("servers:software_catalog_manage");

  if (!institutionUid) {
    return (
      <p className="text-sm text-destructive" role="alert">
        UID de institución no válido.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <nav
        className="flex items-center gap-2 text-sm text-muted-foreground"
        aria-label="Navegación"
      >
        <Button variant="ghost" size="sm" className="cursor-pointer -ml-2" asChild>
          <Link to={`/servers/${institutionUid}`}>
            <ArrowLeft className="h-4 w-4 mr-1" aria-hidden />
            Ficha
          </Link>
        </Button>
        <span aria-hidden>/</span>
        <span className="text-foreground font-medium">Editar</span>
      </nav>

      {isLoading ? (
        <div className="flex justify-center py-16" role="status" aria-live="polite">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          <span className="sr-only">Cargando centro</span>
        </div>
      ) : error ? (
        <p className="text-sm text-destructive" role="alert">
          {error instanceof Error ? error.message : "Error al cargar el centro"}
        </p>
      ) : (
        <CenterInfraDetail
          institutionUid={institutionUid}
          user={user}
          canManageCatalog={canManageCatalog}
        />
      )}
    </div>
  );
}
